import { render, staticRenderFns } from "./ChooseDatasets.vue?vue&type=template&id=7b479ec7&scoped=true&"
import script from "./ChooseDatasets.vue?vue&type=script&lang=js&"
export * from "./ChooseDatasets.vue?vue&type=script&lang=js&"
import style0 from "./ChooseDatasets.vue?vue&type=style&index=0&id=7b479ec7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b479ec7",
  null
  
)

export default component.exports